import { Component, OnInit } from '@angular/core';

import { LayoutConfigService, ToggleOptions } from '@app/core/_base/layout';
import { AuthService } from '@app/core/auth';
import { UserRoleConstants } from '@app/core/staff/store/staff.model';
import { environment } from '@app/env-service';
import { FeatureToggleService } from '@app/shared/services/feature-toggle.service';
import { router } from '@uni/router/router';

import { HtmlClassService } from '../../html-class.service';

@Component({
  selector: 'kt-brand',
  styleUrls: ['./brand.component.scss'],
  templateUrl: './brand.component.html',
})
export class BrandComponent implements OnInit {
  headerLogo :string;
  headerStickyLogo :string;

  clientConfig :any = environment.clientConfig;

  toggleOptions :ToggleOptions = {
    target: 'body',
    targetState: 'kt-aside--minimize',
    togglerState: 'kt-aside__brand-aside-toggler--active',
  };

  constructor(
    private layoutConfigService :LayoutConfigService,
    public htmlClassService :HtmlClassService,
    private authService :AuthService,
    private ft :FeatureToggleService,
  ) {}

  ngOnInit() :void {
    this.headerLogo = this.layoutConfigService.getLogo();
    this.headerStickyLogo = this.layoutConfigService.getStickyLogo();
  }

  logoClick() {
    let url;
    switch (this.authService.getUser().role) {
      case UserRoleConstants.SUPER_ADMIN:
        url = '/inventory/skus';
        break;
      case UserRoleConstants.SALES_MEMBER:
        url = '/sales/crm/companies';
        break;
      default:
        url = '/inventory/skus';
    }
    router.navigate(url);
  }
}
